import Layout from '@/layout/index.vue'
import RouterViewWrapper from '@/features/configurare-aplicatie/components/RouterViewWrapper.vue'

export const ConfigurareAplicatieRoutes = {
  path: '/app-settings',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import('@/features/configurare-aplicatie/views/index.vue'),
      name: 'ConfigurareAplicatieRoute',
      meta: {
        title: 'ConfigurareAplicatieRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'advance-notifications',
      component: (): Promise<any> =>
        import(
          '@/features/configurare-aplicatie/views/advance-notifications.vue'
        ),
      name: 'AdministrareNotificariInAvansRoute',
      meta: {
        title: 'Administrare notificări în avans',
        requiresAuth: true
      }
    },
    {
      path: 'calendar-notifications',
      component: (): Promise<any> =>
        import(
          '@/features/configurare-aplicatie/views/calendar-notifications.vue'
        ),
      name: 'AdministrareNotificariCalendarRoute',
      meta: {
        title: 'Administrare notificări',
        requiresAuth: true
      }
    },
    {
      path: 'custom-fields',
      component: RouterViewWrapper,
      children: [
        {
          path: '',
          component: (): Promise<any> =>
            import('@/features/campuri-personalizate/views/index.vue'),
          name: 'CampuriPersonalizateRoute',
          meta: {
            title: 'Câmpuri personalizate',
            requiresAuth: true
          }
        },
        {
          path: 'create',
          component: (): Promise<any> =>
            import('@/features/campuri-personalizate/views/create-update.vue'),
          name: 'CreateCampuriPersonalizateRoute',
          meta: {
            title: 'Creare câmp personalizat',
            requiresAuth: true,
            action: 'create'
          }
        },
        {
          path: 'edit/:campPersonalizatId',
          component: (): Promise<any> =>
            import('@/features/campuri-personalizate/views/create-update.vue'),
          name: 'EditCampuriPersonalizateRoute',
          meta: {
            title: 'Editare câmp personalizat',
            requiresAuth: true,
            action: 'edit'
          }
        }
      ]
    },
    {
      path: 'contract-types',
      component: RouterViewWrapper,
      children: [
        {
          path: '',
          component: (): Promise<any> =>
            import('@/features/contract-types/views/index.vue'),
          name: 'ContractTypesIndexRoute',
          meta: {
            title: 'ContractTypesIndexRouteTitle',
            requiresAuth: true
          }
        },
        {
          path: 'create',
          component: (): Promise<any> =>
            import('@/features/contract-types/views/create.vue'),
          name: 'ContractTypesCreateRoute',
          meta: {
            title: 'ContractTypesCreateRouteTitle',
            requiresAuth: true
          }
        },
        {
          path: 'edit/:tipContractId',
          component: (): Promise<any> =>
            import('@/features/contract-types/views/edit.vue'),
          name: 'ContractTypesEditRoute',
          meta: {
            title: 'ContractTypesEditRouteTitle',
            requiresAuth: true
          }
        }
      ]
    }
  ]
}
